// Helpers of the contract Clauses tab (spec 2026-10-27-05): where the
// read-only assets block goes, and which clauses are hidden by default.

/**
 * The clause family that carries the contract's assets block, by root
 * contract type family: where the leased lots (H), the insured assets (E) and
 * the covered equipment (B) used to be asked as a property. Other families
 * get no block.
 */
export const ASSETS_BLOCK_FAMILY: Record<string, string> = {
  LEASE: 'H',
  INSURANCE: 'E',
  CONTRACTING_WORK: 'B',
}

interface TypeNode {
  uid: string
  code: string
  parent_contract_type_uid?: string | null
}

/**
 * The code of the root family of a contract type (LEASE_COMMERCIAL → LEASE),
 * walking the parent links. Undefined when the type is unknown; a cycle stops
 * at the last type seen.
 */
export function contractTypeRootCode(types: TypeNode[], uid: string | undefined): string | undefined {
  if (!uid) return undefined
  const byUid = new Map(types.map(t => [t.uid, t]))
  let node = byUid.get(uid)
  const seen = new Set<string>()
  while (node?.parent_contract_type_uid && !seen.has(node.uid)) {
    seen.add(node.uid)
    const parent = byUid.get(node.parent_contract_type_uid)
    if (!parent) break
    node = parent
  }
  return node?.code
}

/** The family the assets block goes in for a contract type, if any. */
export function assetsBlockFamily(types: TypeNode[], uid: string | undefined): string | undefined {
  const root = contractTypeRootCode(types, uid)
  return root ? ASSETS_BLOCK_FAMILY[root] : undefined
}

/**
 * A property flagged `hidden` is stored but hidden by default: a uid property
 * or a vague label whose real link is a relation. The Clauses tab shows it
 * greyed only when the person reveals the hidden properties.
 */
export function isHiddenProperty(def: { flags?: string[] | null } | undefined): boolean {
  return !!def?.flags?.includes('hidden')
}
